import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { auth } from "./firebaseConfig";

const provider = new GoogleAuthProvider();

const register = () => {
  return signInWithPopup(auth, provider).then((result) => {
    return result.user;
  });
};

const signOutUser = async () => {
  await signOut(auth);
};

export { register, signOutUser };
